/**
 * @generated SignedSource<<ab6f59cd5243b57e534bf75f1a419187>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsCurrentTier_tradeFirm$data = {
  readonly rewards: {
    readonly currentProgram: {
      readonly programInfo: {
        readonly code: string | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsNextStatus_tradeFirm" | "useTradeBenefitsContact_tradeFirm">;
  readonly " $fragmentType": "TradeBenefitsCurrentTier_tradeFirm";
};
export type TradeBenefitsCurrentTier_tradeFirm$key = {
  readonly " $data"?: TradeBenefitsCurrentTier_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsCurrentTier_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsCurrentTier_tradeFirm",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useTradeBenefitsContact_tradeFirm"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TradeBenefitsNextStatus_tradeFirm"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ParentProgram",
          "kind": "LinkedField",
          "name": "currentProgram",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "code",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "a02425d5510224a2d7d62d47e2d57ce0";

export default node;
